import { Grid, Box, Tab, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../components/ReusableComponents/title";
import "../../assets/css/accountanalysis.scss";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";
import BalanceChart from "./../../components/Charts/BalanceChart";
import BalanceCurve from "./../../components/Charts/BalanceCurveChart";
import ProfitlossChart from "../../components/Charts/ProfitLossChart";
import FinalEvalTable from "../../components/AccountAnalysis/FinalEvalTable";
import LongShortBalance from "../../components/AccountAnalysis/LongShortBalance";
import ResultbyDays from "./../../components/AccountAnalysis/ResultByDays";
import LongShortComparison from "../../components/AccountAnalysis/LongShortComparison";
import TradingdaysAnalysis from "./../../components/AccountAnalysis/TradingdaysAnalysis";
import ResultsByPosition from "../../components/AccountAnalysis/ResultsbyPosition";
import ResultsByTrade from "../../components/AccountAnalysis/ResultsbyTrade";
import ResultsByOpenHour from "../../components/AccountAnalysis/ResultsbyOpenHour";
import { axiosInstance } from "../../Axios";
import { formatDate, dollarUS } from "../../utilities/formatters";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import useMobile from "../../hooks/useMobile";

const Analysis = ({
  TabShow,
  handleChange,
  onClickTabs,
  radioTab,
  radio,
  AnalysisData,
}) => {
  return (
    <>
      <div className="d-flex align-items-center mbb-20 account-analysis-selector" onClick={onClickTabs}>
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mrr-10"
        >
          <circle cx="4" cy="4" r="4" fill="#04D9FF" />
        </svg>
        <Title four>{radioTab}</Title>
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2854 10.4646C19.6271 10.8063 19.6271 11.3603 19.2854 11.702L14.6188 16.3687C14.2771 16.7104 13.723 16.7104 13.3813 16.3687L8.71466 11.702C8.37295 11.3603 8.37295 10.8063 8.71466 10.4646C9.05636 10.1229 9.61038 10.1229 9.95209 10.4646L14 14.5125L18.048 10.4646C18.3897 10.1229 18.9437 10.1229 19.2854 10.4646Z"
            fill="white"
          />
        </svg>
      </div>
      <Grid container className="test" sx={{ justifyContent: "center" }}>
        {TabShow && (
          <div className="TabShow">
            <div className="SubTabs">
              <div
                className="SubTavItems"
                onClick={handleChange}
                value="LongShortBalance"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "LongShortBalance" && " RBSelected")
                  }
                ></div>
                <Title seven>Long / Short Balance</Title>
              </div>

              <div
                className="SubTavItems"
                onClick={handleChange}
                value="Resultsbydays"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "Resultsbydays" && " RBSelected")
                  }
                ></div>
                <Title seven>Results by days</Title>
              </div>

              <div
                className="SubTavItems"
                onClick={handleChange}
                value="LongShortComparison"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "LongShortComparison" && " RBSelected")
                  }
                ></div>
                <Title seven>Long / Short Comparison</Title>
              </div>

              <div
                className="SubTavItems"
                onClick={handleChange}
                value="TradingdaysAnalysis"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "TradingdaysAnalysis" && " RBSelected")
                  }
                ></div>
                <Title seven>Trading days Analysis</Title>
              </div>

              <div
                className="SubTavItems"
                onClick={handleChange}
                value="ResultsbyPosition"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "ResultsbyPosition" && " RBSelected")
                  }
                ></div>
                <Title seven>Results by Position size</Title>
              </div>

              <div
                className="SubTavItems"
                onClick={handleChange}
                value="ResultsbyTrade"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "ResultsbyTrade" && " RBSelected")
                  }
                ></div>
                <Title seven>Results by Trade Duration</Title>
              </div>

              <div
                className="SubTavItems"
                onClick={handleChange}
                value="ResultsbyOpenHour"
              >
                <div
                  className={
                    "d-flex DotNotclicked " +
                    (radio === "ResultsbyOpenHour" && " RBSelected")
                  }
                ></div>
                <Title seven>Results by Open Hour</Title>
              </div>
            </div>
          </div>
        )}

          {radio === "LongShortBalance" || radio === "AlphaCapitalAccount" ? (
            <Grid container item>
              <LongShortBalance
                data={AnalysisData && AnalysisData.long_short_comp}
              />
            </Grid>
          ) : radio === "Resultsbydays" ? (
            <ResultbyDays data={AnalysisData && AnalysisData.day_wise_data} />
          ) : radio === "LongShortComparison" ? (
            <LongShortComparison data={AnalysisData} />
          ) : radio === "TradingdaysAnalysis" ? (
            <TradingdaysAnalysis
              data={AnalysisData && AnalysisData.trading_days_analysis}
              days={
                AnalysisData &&
                AnalysisData.final_evaluation.minimum_10_training_days
              }
            />
          ) : radio === "ResultsbyPosition" ? (
            <ResultsByPosition
              data={AnalysisData && AnalysisData.results_by_lots}
            />
          ) : radio === "ResultsbyTrade" ? (
            <ResultsByTrade
              data={AnalysisData && AnalysisData.result_by_trade_duration}
            />
          ) : radio === "ResultsbyOpenHour" ? (
            <ResultsByOpenHour
              data={AnalysisData && AnalysisData.result_by_open_hour}
            />
          ) : (
            <LongShortBalance
              data={AnalysisData && AnalysisData.long_short_comp}
            />
          )}
      </Grid>
    </>
  );
};

export default Analysis;
